import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Landmark } from "lucide-react";
import Logo from "./Logo";
import SecurityBadge from "./SecurityBadge";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#050A1F]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <Logo />
          <p className="mt-6 max-w-md font-serif text-2xl font-light text-white/90">
            Underwritten with discretion. Delivered with speed.
          </p>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
            Lending Loan USA provides tailored personal and business financing to
            discerning American clients — every transaction protected by
            bank-grade security infrastructure.
          </p>
          <div className="mt-8">
            <SecurityBadge compact />
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.28em] text-[#D4AF37]">Company</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li><a href="/#about" className="hover:text-[#D4AF37]">About Us</a></li>
            <li><a href="/#services" className="hover:text-[#D4AF37]">Services</a></li>
            <li><a href="/#how-it-works" className="hover:text-[#D4AF37]">How It Works</a></li>
            <li><a href="/#faq" className="hover:text-[#D4AF37]">FAQ</a></li>
            <li><Link to="/admin/login" className="hover:text-[#D4AF37]" data-testid="footer-admin-login">Admin Portal</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.28em] text-[#D4AF37]">Contact</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 text-[#D4AF37]" strokeWidth={1.6} />
              <a href="tel:+12022800579" className="hover:text-[#D4AF37]" data-testid="footer-phone">
                +1 (202) 280-0579
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 text-[#D4AF37]" strokeWidth={1.6} />
              <a href="mailto:support@lendingloansusa.com" className="hover:text-[#D4AF37]" data-testid="footer-email">
                support@lendingloansusa.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 text-[#D4AF37]" strokeWidth={1.6} />
              <span>1200 K Street NW, Suite 800<br />Washington, DC 20005</span>
            </li>
            <li className="flex items-start gap-3">
              <Landmark className="mt-0.5 h-4 w-4 text-[#D4AF37]" strokeWidth={1.6} />
              <span>NMLS# 000000 · Est. 2014</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 text-xs text-white/40 lg:flex-row lg:items-center lg:px-10">
          <p>© {new Date().getFullYear()} Lending Loan USA. All rights reserved.</p>
          <p className="tracking-[0.28em] uppercase">Bank-Grade Security · 256-bit Encryption</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
